import { Link } from "react-router-dom";
import { Split, Arrow } from "@/components/hm/Basics";

export const ParentsTeaser = () => (
  <section className="sec welcome-mod" id="padres" data-testid="landing-parents">
    <div className="wrap">
      <div className="sec-head">
        <span className="eyebrow">Para padres y madres</span>
        <Split className="hm-h1" text="Si eres padre o madre" serif="y estás aquí…" data-testid="landing-parents-title" />
        <p className="lead rv" data-testid="landing-parents-text">
          Si has llegado porque ves a tu hijo o hija apagado, sin energía, sin motivación o desconectado de sí mismo, no estás solo.
          <br /><br />Muchos jóvenes están viviendo cambios internos profundos que el sistema educativo no sabe acompañar. Heartmony también es un espacio para ti: para entender qué le pasa, cómo apoyarlo y cómo ayudarle a recuperar claridad y dirección interna.
          <br /><br />Aquí puedes ver cómo funciona Heartmony para jóvenes y cómo puedes acompañarlo en este proceso.
        </p>
      </div>
      <div className="wm-cta rv" style={{ justifyContent: "flex-start" }}>
        <Link to="/padres" className="btn btn-primary btn-hm wm-btn" data-testid="landing-parents-cta">Información para padres y madres <Arrow /></Link>
      </div>
    </div>
  </section>
);
